import { api } from './api';
import { ActionDispatching, ConstraintResponseType } from 'app/types-shared';
import { ReceiveCallsToActions, ReceiveChangeCaseStatus, RequestCallsToActions, 
  RequestChangeCaseStatus } from 'app/area/case/features/calls-to-actions/action-types';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import { ComplexValue } from 'ui';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';

const toasts = toastFactory();
export const actionCreators = {     
  callsToActions: (caseId: number): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      await dispatch(new RequestCallsToActions(caseId));
      try {
        const callsToActions = await api.callsToActions(caseId);
        await dispatch(new ReceiveCallsToActions(callsToActions));
        return callsToActions;
      }
      catch(err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
      }
    },

    onChangeCaseStatus: (caseId: number, status : ComplexValue<number>, allowWarnings: boolean = true): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      try {
        const caseResponse = await api.case(caseId);
        const etag = caseResponse.etag;
        const caseData = caseResponse.json.data;
        const statusField = caseData.fields.Status?.values?.[0];
        if(!statusField) {
          return null;
        }
        statusField.v = status?.value;
        statusField.d = status?.description;
        await dispatch(new RequestChangeCaseStatus(caseId));
        const saveCaseResponse = await api.changeCaseStatus(caseData, etag, true, allowWarnings);   
        await dispatch(new ReceiveChangeCaseStatus(status));
        if(allowWarnings) {
          const warnings = saveCaseResponse.json.data.metaData.failedDomainConstraints;
          if(!!warnings?.length) {
            return { warnings: warnings };
          }
        }
      }
      catch(err) {
        return { userMessages: err.userMessages, 
          validationErrors: err.validationErrors?.filter(err=>err.responseType === ConstraintResponseType.Error),
          warnings: err.validationErrors?.filter(err=>err.responseType === ConstraintResponseType.Warning)}
    }
    return null;
  }
};
